'use client';

//* Modules
import Custom404Template from '@/modules/Custom404';

const NotFound = () => {
	return <Custom404Template />;
};

export default NotFound;
